export default __webpack_public_path__ + "static/media/applePay.eedfd629.JPEG";